import ApiServiceV6Core from '@/helpers/api.service.v6core';

const APIV6Core = new ApiServiceV6Core();
import axios from 'axios';


export const state = {
   
}

export const mutations = {
    
}

export const actions = {
    actionCoreSKUTestAPIPOST(_, {params, action, hidePreloader = false}) {
        return new Promise((resolve, reject) => {
            if (hidePreloader) {
                // Use axios directly with hidePreloader config
                const API_URL = process.env.VUE_APP_APIURL + '/v6/core';
                axios.post(`${API_URL}/eload/test/${action}`, params, { hidePreloader: true })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            } else {
                // Use normal API service (with preloader)
                APIV6Core.post(`/eload/test/${action}`, params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            }
        });
    },
    actionCoreSKUTestAPIGET(_, {params, action, hidePreloader = false}) {
        return new Promise((resolve, reject) => {
            if (hidePreloader) {
                // Use axios directly with hidePreloader config
                const API_URL = process.env.VUE_APP_APIURL + '/v6/core';
                axios.get(`${API_URL}/eload/test/${action}`, { params, hidePreloader: true })
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            } else {
                // Use normal API service (with preloader)
                APIV6Core.get(`/eload/test/${action}`, params)
                .then((response) => {
                    resolve(response.data);
                })
                .catch((error) => {
                    reject(error);
                });
            }
        });
    },
}

export const getters = {
    
}